<template>
    <div class="form-field font-field">
        <label>字体</label>
        <div class="content">
            <!--<el-select :value="face" @input="setFontFamily" placeholder="请选择字体" size="mini">-->
                <!--<el-option-->
                        <!--v-for="item in fontList"-->
                        <!--:style="{fontFamily:item.value === 'default'?null:item.value}"-->
                        <!--:key="item.value"-->
                        <!--:label="item.label"-->
                        <!--:value="item.value">-->
                <!--</el-option>-->
            <!--</el-select>-->
            <div class="options">
                <!--<div :class="{'form-icon-button':true,active:style.fontWeight === 'bold'}" @click="setBold">-->
                    <!--<i class="icon-bold"></i>-->
                <!--</div>-->
                <!--<div :class="{'form-icon-button':true,active:style.textDecoration === 'underline'}"-->
                     <!--@click="setUnderline">-->
                    <!--<i class="icon-underline"></i>-->
                <!--</div>-->
                <!--<div :class="{'form-icon-button':true,active:style.fontStyle === 'italic'}" @click="setItalic">-->
                    <!--<i class="icon-italic"></i>-->
                <!--</div>-->
                <el-select class="select" :value="size" @input="setFontSize" placeholder="字体大小" size="mini">
                    <el-option
                            v-for="item in fontSize"
                            :key="item"
                            :label="item + 'px'"
                            :value="item">
                    </el-option>
                </el-select>
            </div>
            <!--<input class="overlay-input" type="text" :value="size" @blur="setFontSize($event.target.value)"/>-->
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .content {
        position: relative;
    }

    .form-field {
        align-items: center;
    }

    .options {
        /*margin-top: 5px;*/
    }

    .select{
        width:90px;
    }

    .overlay-input {
        outline: none;
        width: 54px;
        height: 18px;
        line-height: 18px;
        padding-right: 0 !important;
        color: #DDDDDD;
        border: 0;
        background: #292929;
        position: absolute;
        /*bottom: 3px;*/
        /*right: 21px;*/
        bottom:2px;
        left:1px;
    }
</style>

<script>
	import style from 'mixins/style'
	import _ from 'lodash'
	import {createFont} from 'utils/helper'

	export default {
		mixins: [ style ],
		data() {
			return {
				fontSize: [ 14, 20, 24, 30, 36, 60, 128 ],
			}
		},
		computed: {
			fontList() {
				return []
			},
			face() {
				return this.style.fontFamily || "default"
			},
			size() {
				return this.style.fontSize
			},
			style() {
				return this.selected.style || {}
			},
			selected() {
				return this.$store.state.selected
			}
		},
		methods: {
			setFontFamily(value) {
				this.$store.commit('update_elm_style', {
					id: this.selected.id,
					data: {
						fontFamily: value
					}
				})
			},
			setFontSize(value) {
				this.$store.commit('update_elm_style', {
					id: this.selected.id,
					data: {
						fontSize: parseFloat(value)
					}
				})
			},
			setBold() {
				this.$store.commit('update_elm_style', {
					id: this.selected.id,
					data: {
						fontWeight: this.style.fontWeight === 'bold' ? 'normal' : 'bold'
					}
				})
			},
			setUnderline() {
				this.$store.commit('update_elm_style', {
					id: this.selected.id,
					data: {
						textDecoration: this.style.textDecoration === 'underline' ? 'none' : 'underline'
					}
				})
			},
			setItalic() {
				this.$store.commit('update_elm_style', {
					id: this.selected.id,
					data: {
						fontStyle: this.style.fontStyle === 'italic' ? 'normal' : 'italic'
					}
				})
			}
		}
	}
</script>
